import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { CompareTable } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import TrackPznOfferImpression from './TrackPznOfferImpression';

import {
  makeGetSelectedCards,
  getOverviewKeys,
  getOverviewContent,
  getProductOverviewContent,
  getCardOverviewData
} from '../redux.js';

import { useBreakpoint } from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

import styles from '../__styles__/sharedComparisonTable.scss?modules';
import customStyles from '../__styles__/overviewTable.scss?modules';

import { CurrentPermutationContext } from '../index.js';

const OverviewTable = ({
  cards,
  cardAttributes,
  attributeContent,
  cardContent,
  overviewData
}) => {
  const { sm } = useBreakpoint();
  const { currentPermutations } = useContext(CurrentPermutationContext);

  const visibleCards = sm
    ? [cards[currentPermutations[0] - 1], cards[currentPermutations[1] - 1]]
    : cards;

  const visibleCardContent = sm
    ? [
        cardContent[currentPermutations[0] - 1],
        cardContent[currentPermutations[1] - 1]
      ]
    : cardContent;

  return (
    <div className={styles.container}>
      <TrackPznOfferImpression />
      <LazyScrollMetricTracker scrollDtm={overviewData?.dtm} />
      <CompareTable
        qeId={'gcsCompareOverview'}
        cards={visibleCards}
        cardAttributes={cardAttributes}
        attributeContent={attributeContent}
        cardContent={visibleCardContent}
        tableName={
          <Sanitizer Component="h2" safelySetInnerHTML={overviewData.header} />
        }
        styles={customStyles}
      />
    </div>
  );
};

const mapStateToProps = () => {
  const getSelectedCards = makeGetSelectedCards();

  return state => ({
    cards: getSelectedCards(state),
    cardAttributes: getOverviewKeys(state),
    attributeContent: getOverviewContent(state),
    cardContent: getProductOverviewContent(state),
    overviewData: getCardOverviewData(state)
  });
};

export default connect(mapStateToProps)(OverviewTable);
